import Swiper from 'swiper'
import { getLocalURL } from '../../../scripts/helpers/globale'

export default class AccountNav {
  constructor(component) {
    this.dom = {
      $component: component,
      $wishListLink: component.querySelector('.js-iWishLink')
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    this.initSlider()

    if (dom.$wishListLink) {
      dom.$wishListLink.addEventListener('click', this.wishListLinkClick)
    }
  }

  initSlider() {
    const {dom} = this
    const swiper = new Swiper('.js-accountNavContainer', {
      slidesPerView: 'auto',
      spaceBetween: 18,
      breakpoints: {
        600: {
          allowTouchMove: false
        }
      }
    })
  }

  wishListLinkClick(e) {
    if (typeof(Storage) !== 'undefined') {
      e.preventDefault()
      iWishPost(getLocalURL('/apps/iwish'), {
        iwishlist:JSON.stringify(iWishlistmain),
        cId:iwish_cid
      })
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountPage = this
  }
}
